<div class="form-io-manager">
  <formio
    #formIo
    [form]="form()"
    [hideLoading]="true"
    [options]="{
      disableAlerts: true,
    }"
    [renderOptions]="{
      language: 'en',
      i18n: {
        en: {
          previous: 'Back',
          submit: 'Submit',
        },
      },
    }"
    [submission]="{
      data: data(),
    }"
    (render)="onRender()"
    (submit)="onSubmit()"
    (customEvent)="onCustomEvent($event)"
    (nextPage)="onNext($event)"
    (change)="onChange($event)"
  ></formio>
</div>
